// #region 极验失败时返回数据
/**
 * us环境的页面取不到google recaptcha_token的时候 ，recaptcha_token参数传入
 */
export const GOOGLE_ERROR_MESSAGE = {
    recaptcha_token: 'connected_failed_from_google_recapcha_ui',
};
/**
 * cn环境页面取不到geetest passtoken的时候，pass_token传入
 */
export const GEETEST_ERROR_MESSAGE = {
    pass_token: 'connected_failed_from_geetest_ui',
};
export const CLOSE = 'close';
// #endregion
